/**
 * FeelGood 问卷调查相关常量配置
 */
//  下标就是 FEELGOOD 后台 ，问卷的序号
export const FEELGOOD_SURVEY = {
  satisfaction: '6825937971607240709', // 01 整体满意度
  openAccount: '6825942106633142277', // 02 开户
  dataFunction: '6825955593279242246', // 03 数据功能（Dashboard&Report）
  promotionManagement: '6825958407871135750', // 04 推广管理列表
  adCreate: '6825960554662723590', // 05 广告创编
  createTool: '6825961883376287749', // 06 创意工具
  deliveryEffect: '6825963906477850629', // 07 投放效果
  audit: '6825960837681774598', // 08 审核
  operatingEfficiency: '6825959206982516741', // 09 操作效率
  test: '6830311651661578246', // 10 测试
  batch: '6946067813492588545', // 批量feedback
  diagnosis: '6971311861534818306', // 诊断问券
  aco: '6966439410590023682', // 关停 ACO 广告
  viewdata: '7012428935845642241', // viewdata 问卷
  smbSuggestion: '7033588848214933506',
};

/**
 * feelgood 触发条件行为
 * feelgood 后台可以配置问卷的触发行为，这样就可以不用在前端使用问卷ID的方式触发,方便后续同样的行为替换新问卷
 */
export const FEELGOOD_EVENT = {
  newUser: 'new_user', // 新手开户30天内
  viewAudit: 'view_audit', // 查看审核意见抽屉后
  useCreativeTool: 'use_creative_tool', // 使用完创意工具后
  completeCreation: 'complete_creation', // 完成一次创编
  completeAdDelivery: 'complete_ad_delivery', // 完成广告投放后
  turnOffAco: 'turn_off_aco', // 关停 ACO 广告
  openViewData: 'open_viewdata', // 打开 viewdata 抽屉
  useCustomIdentity: 'use_custom_identity', // 使用自定义Identity账号完成创编
  useTtaIdentity: 'use_tta_identity', // 使用TTA Identity账号完成创编
  useTtbaIdentity: 'use_ttba_identity', // 使用TTBA Identity账号完成创编
  accountSuspend: 'account_suspend', // 使用TTBA Identity账号完成创编
};

// 竞价平台的国际化标识，和 feelgood 语言标识不太一样，做一个映射
// feelgood 支持语言列表 https://site.bytedance.net/docs/2626/3150/23091/#setlanguage-lang-string
export const ADS_LANG_2_FEELGOOD_LANG = {
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KR',
  ms: 'en_US', // 这个feelgood暂时不支持，默认英文
  ru: 'ru_RU',
  th: 'th_TH',
  tr: 'en_US', // 这个feelgood暂时不支持，默认英文
  vi: 'vi_VI',
  zh: 'zh_CN',
  ar: 'en_US', // 这个feelgood暂时不支持，默认英文
};

// 账号类型对应的中文名称，方便数据分析师处理
// 数字对应的角色参考 src/const/state/account.js
export const CUSTOMER_TYPE_NAME = {
  0: '一般广告主',
  1: '广告代理商',
  2: '虚拟广告主',
  3: '管理员',
  4: '内部广告主',
  6: '二级代理商',
  7: '头条号文章作者',
  8: '头条自建DSP广告主',
  13: '账号管家',
  101: '直客',
  104: '自助客户',
};
